import React, { useState } from 'react';
import { TextField, Button, Stack, Typography } from '@mui/material';

const OrganizationsForm = ({ onSubmit, initialData }) => {
  const [form, setForm] = useState(initialData || {
    identifier: '',
    displayName: '',
    description: '',
    website: '',
    reason: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h6">Organization Form</Typography>
      <Stack spacing={2} direction="column" sx={{ my: 2 }}>
        <TextField
          label="Identifier"
          name="identifier"
          value={form.identifier}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Display Name"
          name="displayName"
          value={form.displayName}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Description"
          name="description"
          value={form.description}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Organization Website"
          name="website"
          value={form.website}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Reason"
          name="reason"
          value={form.reason}
          onChange={handleChange}
          fullWidth
        />
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </Stack>
    </form>
  );
};

export default OrganizationsForm;
